import {useField, ErrorMessage} from 'formik';

import {FieldMargin} from '../../_old/FieldHelpers/FieldContainers';
import {FormError} from '../../_old/FieldHelpers/FormError';

import {MultiTextField} from './MultiTextField';

type Props = {
  name: string;
  label: string;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
};
export function MultiTextFieldWithFormik(props: Props): React.JSX.Element {
  const [field, , helpers] = useField<string[]>(props.name);

  const submitFn = (v: string): void => {
    if (v !== '') {
      if (field.value) {
        helpers.setValue([...field.value, v]);
      } else {
        helpers.setValue([v]);
      }
    }
    helpers.setTouched(true, true);
  };

  const removeFn = (item: string): void => {
    const filteredList = field.value.filter((l: string) => l !== item);
    helpers.setValue(filteredList);
    helpers.setTouched(true, true);
  };

  return (
    <FieldMargin onBlur={field.onBlur}>
      <MultiTextField
        name={props.name}
        label={props.label}
        collection={field.value}
        submitFn={submitFn}
        removeFn={removeFn}
        inputProps={props.inputProps}
      >
        <ErrorMessage name={props.name} component={FormError} />
      </MultiTextField>
    </FieldMargin>
  );
}
export function MultiTextFieldWithFormik2(props: Props): React.JSX.Element {
  const [field, meta, helpers] = useField<string[]>(props.name);

  const submitFn = (v: string): void => {
    if (v !== '') {
      if (field.value) {
        helpers.setValue([...field.value, v]);
      } else {
        helpers.setValue([v]);
      }
    }
    helpers.setTouched(true, true);
  };

  const removeFn = (item: string): void => {
    const filteredList = field.value.filter((l: string) => l !== item);
    helpers.setValue(filteredList);
    helpers.setTouched(true, true);
  };

  return (
    <FieldMargin onBlur={field.onBlur}>
      <MultiTextField
        name={props.name}
        label={props.label}
        collection={field.value}
        submitFn={submitFn}
        removeFn={removeFn}
        inputProps={props.inputProps}
      >
        {meta.error &&
          meta.touched &&
          [
            ...new Set([
              // @ts-expect-error formik zod not sure idk
              ...meta.error._errors,
              ...Object.values(meta.error)
                // @ts-expect-error formik zod not sure idk
                .map((e) => e._errors)
                .filter((v) => !!v)
                .flat(),
            ]),
          ].map((error) => <FormError key={error}>{error}</FormError>)}
      </MultiTextField>
    </FieldMargin>
  );
}

MultiTextFieldWithFormik.displayName = 'MultiTextFieldWithFormik';
